module.exports = __webpack_public_path__ + "static/media/Merrill-Kunz_160px.70914010.jpg";